import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const helpCenterSettingsAgentStudioHandoffEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-help-center-settings-agent-studio-handoff-config" */ './index'
			),
	),
	getPreloadProps: () => ({}),
});
